import { BadgeButton, BadgeProps } from "src/components/base/badges/base";
import React from "react";
import { useLocation } from "@tanstack/react-router";

export type SubnetBadgeProps = {
    /**
     * The subnet this badge is for
     *
     * The type is intentionally not from the generated sdk
     * to support as many caller as possible
     */
    subnet: { uuid: string; name: string; description?: string };

    /** Optional color to use instead of the default (`"blue"`) */
    color?: BadgeProps["color"];

    /** Additional classname to set */
    className?: string;
};

export function SubnetBadge(props: SubnetBadgeProps) {
    const location = useLocation();
    const href = location.href.startsWith("/c")
        ? "/c/subnets/$subnetId/inbound-acls"
        : "/a/subnets/$subnetId/inbound-acls";

    return (
        <BadgeButton
            className={props.className}
            color={props.color ?? "blue"}
            href={href}
            params={{ subnetId: props.subnet.uuid }}
            title={props.subnet.description}
        >
            {`subnet:${props.subnet.name}`}
        </BadgeButton>
    );
}
